import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import StructuredData from '@/components/base/StructuredData';
import Breadcrumb from '@/components/base/Breadcrumb';
import { articles } from '@/mocks/articles';

const categoryTabs = [
  { key: 'all', label: '全部文章' },
  { key: 'news', label: '平台动态' },
  { key: 'guide', label: '新手指南' },
  { key: 'strategy', label: '游戏攻略' },
];

export default function ArticlesPage() {
  const [activeTab, setActiveTab] = useState('all');

  const filteredArticles = activeTab === 'all'
    ? articles
    : articles.filter((a) => a.category === activeTab);

  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: '最新资讯' },
  ];

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '最新资讯 - 澳门新葡京娱乐平台',
    description: '了解澳门新葡京最新动态、游戏攻略和新手指南，获取最全面的娱乐平台资讯信息。',
    url: 'https://www.xinpujing.mo/articles',
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.xinpujing.mo/' },
      { '@type': 'ListItem', position: 2, name: '最新资讯' },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <StructuredData data={webPageSchema} />
      <StructuredData data={breadcrumbSchema} />
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-100 border-b border-background-200/70">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb items={breadcrumbItems} />
            <div className="px-4 md:px-6 pb-6">
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
                最新资讯
              </h1>
              <p className="text-sm text-foreground-500">
                了解澳门新葡京最新动态、游戏攻略和新手指南
              </p>
            </div>
          </div>
        </div>

        <div className="sticky top-16 z-30 bg-background-50/95 backdrop-blur-md border-b border-background-200/70">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center gap-1 overflow-x-auto py-3 scrollbar-hide flex-wrap">
              {categoryTabs.map((tab) => (
                <button
                  key={tab.key}
                  onClick={() => setActiveTab(tab.key)}
                  className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer ${
                    activeTab === tab.key
                      ? 'bg-primary-500 text-background-50'
                      : 'text-foreground-600 hover:text-foreground-950 hover:bg-background-100'
                  }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div>
        </div>

        <section className="w-full py-12 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {filteredArticles.map((article, index) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="group rounded-xl bg-background-100 border border-background-200/70 overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer animate-fade-in-up"
                  style={{ animationDelay: `${index * 0.06}s` }}
                >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={article.imageUrl}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-3 left-3">
                      <span className="px-2.5 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium">
                        {article.categoryLabel}
                      </span>
                    </div>
                  </div>
                  <div className="p-5">
                    <h2 className="text-base md:text-lg font-heading font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors duration-200">
                      {article.title}
                    </h2>
                    <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                      {article.summary}
                    </p>
                    <div className="flex items-center justify-between text-xs text-foreground-400">
                      <div className="flex items-center gap-3">
                        <span>{article.date}</span>
                        <span>{article.author}</span>
                      </div>
                      <span className="flex items-center gap-1 text-primary-600 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                        阅读
                        <i className="ri-arrow-right-line"></i>
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>

            {filteredArticles.length === 0 && (
              <div className="text-center py-16">
                <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-background-200 text-foreground-400 mb-4">
                  <i className="ri-file-list-3-line text-2xl"></i>
                </div>
                <p className="text-foreground-500">暂无相关文章</p>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}